import { useDispatch, useSelector } from 'react-redux'
import DashboardLayout from '../../Layout/Index'
import { AddFoodCategory } from '../../Modals/AddFoodCategory'
import { AddFoodItem } from '../../Modals/AddFoodItem'
import FoodSideBar from '../../components/sidebar/FoodSideBar'
import { fetchFood } from '../../redux/slices/foodSlice'
import { useEffect, useState } from 'react'
import { FiSearch } from 'react-icons/fi'

const FoodCategory = () => {
  const itemsPerPage = 10;

  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null)

  const foods = useSelector((state) => state.food); 
  const menu = useSelector((state) => state?.category);
  const menuList = menu?.category?.data

  useEffect(() => {
    if (menuList?.length > 0 && !selectedCategoryId) {
      setSelectedCategoryId(menuList[0].id);
    }
  }, [menuList, selectedCategoryId]);
  
  useEffect(() =>{
    if (selectedCategoryId) {
      dispatch(
        fetchFood({
        categoryId: selectedCategoryId,
        searchText: searchTerm,
        pageSize: itemsPerPage,
        pageNumber: currentPage,
      }))
      
    }
  }, [dispatch, searchTerm, currentPage, itemsPerPage, selectedCategoryId]);

  useEffect(() => {
    if(foods){
      setTotalRecord(foods?.data?.totalRecord);
    }
  },[foods]);

  const data = foods?.data?.data;

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 py-10 bg-white w-full mt-16">
        <div className="flex items-center justify-between">
          <h1 className="text-xl sm:text-2xl font-bold text-[#FF0000]">Manage Food Menu</h1>
            <AddFoodCategory />
        </div>
          <p className="text-sm md:text-md pb-2 md:pb-0 w-full sm:w-[28rem] md:w-full text-[#0A0A0ACC]">
            Organize and update menu items with ease—create, edit, or remove categories to keep the offerings fresh and enticing.
          </p>
        <div className="h-[1px] w-full border-0 bg-primaryGray my-4" />
        <div className="flex items-center justify-between gap-10">
          <div className="relative">
            <input
              type="search"
              name="search"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search food"
              className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-[150px] sm:w-[250px] md:w-[350px] ring-0 outline-none text-sm lg:text-md placeholder:text-xs md:text-sm"
            />
            <FiSearch className="absolute left-4 top-3 text-lg text-[#A6A9B9]" />
          </div>
          <AddFoodItem />
        </div>
        <p className="text-sm pt-6 lg:pt-3 w-full lg:w-full">
          Choose a category to review and update food items, keeping offerings fresh and appealing for customers.         
        </p>
        <FoodSideBar 
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          selectedCategoryId={selectedCategoryId}
          setSelectedCategoryId={setSelectedCategoryId}
          isLoading={foods?.loading}
          totalRecord={totalRecord}

        />
    </div>
    </DashboardLayout>
  )
}

export default FoodCategory
